import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "store";
import { useEffect } from "react";
import { fetchAssets } from "store/assets/assets.slice";
import { LoadingOutlined } from "@ant-design/icons";
import Partners from "../partners/Partners";

type AssetPageProps = {
  page: string;
  path: string;
};
const AssetPage = ({ page, path }: AssetPageProps) => {
  const dispatch: (arg: any) => AppDispatch = useDispatch();
  const assets = useSelector((store: RootState) => store.assets);
  useEffect(() => {
    dispatch(fetchAssets(path));
  }, [dispatch, page, path]);

  if (!assets.is_fetch) {
    return <LoadingOutlined />;
  }

  return (
    <div className="Page">
      <div
        className="Page-Content Page-Align-Left"
        dangerouslySetInnerHTML={{
          __html: assets[page],
        }}
      />

      {path === "o_nama" && (
        <div className="Page-Content">
          <Partners />
        </div>
      )}
    </div>
  );
};
export default AssetPage;
